<template>
  <div class="brief-datos-imagenes">
    <b-row>
      <b-col cols="12">
        <div class="subtitulo">
          <label>Adjuntos</label>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" md="4" v-for="imagen in imagenes" :key="imagen.id">
        <b-card no-header class="galeria-imagen">
          <template v-if="isImagen(imagen.fileName)">
            <b-img fluid
              @click="consultarImagen(imagen.url)"
              :src="imagen.url"></b-img>
          </template>
          <template v-if="isPDF(imagen.fileName)">
            <div class="galeria-pdf">
              <div @click="consultarPDF(imagen)">
                <pdf 
                  :src="imagen.url"
                  :page="1"
                  :scale="0.8"/>
              </div>
            </div>
          </template>
          <template v-if="isWord(imagen.fileName)">
            <div class="galeria-doc">
              <i class="fa fa-file-word-o fa-2x" @click="downloadFile(imagen)"></i>
              <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
            </div>
          </template>
          <template v-if="isPowerPoint(imagen.fileName)">
            <div class="galeria-doc">
              <i class="fa fa-file-powerpoint-o fa-2x" @click="downloadFile(imagen)"></i>
              <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
            </div>
          </template>
          <template v-if="isExcel(imagen.fileName)">
            <div class="galeria-doc">
              <i class="fa fa-file-excel-o fa-2x" @click="downloadFile(imagen)"></i>
              <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
            </div>
          </template>
          <template v-if="isOtro(imagen.fileName)">
            <div class="galeria-doc">
              <i class="fa fa-file fa-2x" @click="downloadFile(imagen)"></i>
              <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
            </div>
          </template>
          <div class="titulo">
            <h3 v-if="imagen.titulo != ''">{{ imagen.titulo }}</h3>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" md="4" v-for="link in links" :key="link.id">
        <b-card no-header class="galeria-imagen">
          <div class="galeria-doc">
            <i class="fa fa-external-link fa-2x" @click="copyToClipboard(link.link)"></i>
            <label @click="copyToClipboard(link.link)">{{ link.link }}</label>
          </div>
          <div class="titulo">
            <p v-if="link.descripcion != ''" class="text-muted">{{ link.descripcion }}</p>
          </div>

          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
    
    <b-modal ref="imagenModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen">
      <app-imagen
        :url="selectedImageUrl"
        @close="closeImagen">
      </app-imagen>  
    </b-modal>

    <b-modal ref="pdfModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen modalPDF">
      <app-pdf-modal
        :filename="selectedFilename"
        :url="selectedImageUrl"
        @close="closePDF">
      </app-pdf-modal>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Imagen from  '../shared/imagenModal.vue';
import PdfModal from  '../shared/pdfModal.vue';
import pdf from 'vue-pdf'
// import PDFViewer from 'pdf-viewer-vue';
// import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer.js';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'briefDatos/getField',
  mutationType: 'briefDatos/updateField',
});

export default {
  name: 'BriefImagenesData',
  components: {
    appImagen: Imagen,
    appPdfModal: PdfModal,
    pdf,
    // appViewer: PDFViewer,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      labelCols: 2,
      selectedFilename: '',
      selectedImageUrl: '',
      selectedBase64: '',

      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'success',
      alertMsj: ''
    }
  },
  computed: {
    ...mapFields([
      'imagenes',
      'links'
    ]),
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.alertCountDown;
    },
    isImagen(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'jpg' 
          || extension.toLowerCase() == 'png') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'jpeg') {
        return true;
      }

      return false;
    },
    isPDF(fileName) {
      let extension = fileName.slice(-3);
      if (extension == 'pdf') {
        return true;
      }
      return false;
    },
    isWord(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'doc') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'docx') {
        return true;
      }

      return false;
    },
    isPowerPoint(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'ppt') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'pptx') {
        return true;
      }

      return false;
    },
    isExcel(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'xls') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'xlsx') {
        return true;
      }

      return false;
    },
    isOtro(fileName) {
      return !this.isImagen(fileName)
        && !this.isPDF(fileName)
        && !this.isWord(fileName)
        && !this.isPowerPoint(fileName)
        && !this.isExcel(fileName);
    },
    consultarImagen(imageUrl) {
      this.selectedImageUrl = imageUrl;
      this.$refs.imagenModal.show();
    },
    closeImagen() {
      this.$refs.imagenModal.hide();
    },
    consultarPDF(file) {
      this.selectedImageUrl = file.url;
      this.selectedFilename = file.fileName;
      this.$refs.pdfModal.show();
    },
    closePDF() {
      this.$refs.pdfModal.hide();
    },
    downloadFile(file) {
      if (file.url) {
        fetch(file.url)
          .then(res => res.blob())
          .then(blob => {
            saveAs(blob, file.fileName);
          });
      }
    },    
    handleDownload() {
      console.log('handle')
    },
    async copyToClipboard(link) {
      try {
        await navigator.clipboard.writeText(link);

        this.alertMsj = "Se copió el link al portapapeles";
        this.alertCountDown = 3;
        this.showAlert();

        // console.log('Content copied to clipboard');
      } catch (err) {
        this.showErrorMsj(new Error('Esta operación no está permitida'));
        console.error('Failed to copy: ', err);
      }
    },
  },
}
</script>

<style>
  .brief-datos .brief-datos-imagenes {
    min-height: 300px;
  }

  .brief-datos .brief-datos-imagenes .galeria-imagen .card-body {
    max-height: 200px !important;
    overflow: hidden;
  }

  .brief-datos .brief-datos-imagenes .subtitulo,
  .brief-datos .brief-datos-imagenes .subtitulo label,
  .brief-datos .brief-datos-imagenes .subtitulo button {
    display: inline-block !important;
  }
  .brief-datos .brief-datos-imagenes .galeria-pdf {
    cursor: pointer;
  }

  .brief-datos .brief-datos-imagenes .galeria-doc {
    display: block;
  }
  .brief-datos .brief-datos-imagenes .galeria-doc i,
  .brief-datos .brief-datos-imagenes .galeria-doc label {
    display: block;
    cursor: pointer;
  }
  .brief-datos .brief-datos-imagenes .galeria-doc i {
    color: rgb(20,76,129);
    margin-bottom: 10px;
  }
  .brief-datos .brief-datos-imagenes .galeria-doc label {
    margin-bottom: 20px;
  }


  .brief-card-header .card-body {
    padding: 0;
  }
  .brief-card-header .card-body > div {
    padding: 20px;
  }

  .brief-datos .brief-datos-imagenes .titulo p {
    font-size: 0.8em;
  }
</style>
